import React, { useRef } from "react";
import { Theme } from "@material-ui/core/styles";

import { makeStyles, createStyles } from "@material-ui/core";
import EllipsisText from "react-text-overflow-middle-ellipsis";
import style from "./style";
import UITooltip from "../../../Tooltip";

type props = {
  title: string;
};
// Create styles
const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));

export const TitleElement = (props: props): JSX.Element => {
  const classes = useStyles();
  const textElementRef: any = useRef();
  const Title = (props.title || "").toString().trim();

  return (
    <span>
      <UITooltip title={Title || ""} disableTooltip={false}>
        <span>
          <span ref={textElementRef} className={classes.ellipsisContainer}>
            {Title}
          </span>
          <EllipsisText text={Title} />
        </span>
      </UITooltip>
    </span>
  );
};
